<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M10.8333 7.22222V3.05556L18.0556 9.35222L10.8333 15.8333V11.6667C5.00001 11.6667 1.94446 15.8333 1.94446 15.8333C1.94446 15.8333 1.94446 7.22222 10.8333 7.22222Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
